import { render, staticRenderFns } from "./PendingApplicantsTable.vue?vue&type=template&id=37b33842&scoped=true&"
import script from "./PendingApplicantsTable.vue?vue&type=script&lang=ts&"
export * from "./PendingApplicantsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PendingApplicantsTable.vue?vue&type=style&index=0&id=37b33842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b33842",
  null
  
)

export default component.exports